
import { defineComponent } from 'vue'
import { theme } from '@/config/styles'

/**
 * Component utilizado para inserir um botão
 * @prop {String} msg - Texto do botão
 * @event buttonClicked - Evento quando clica o botão
 */
const __default__ = defineComponent({
    props: {
        msg: {
            type: String,
            default: 'Submit',
        },
    },
    emit: ['buttonClicked'],
    inheritAttrs: false,
    setup(props, context) {
        function onClick(): void {
            context.emit('buttonClicked')
        }
        return {
            onClick,
            theme
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "2bcdff84": (_ctx.theme.colors.primary.midlight),
  "25f1aeb6": (_ctx.theme.colors.white)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__